import EventFormPageActionTypes from './event-form-page-action-types';
import ValidationError from '../../../utils/validation-error';

export const loadEventFormPage = ({ eventId }) => async(dispatch, getState, { api }) => {
  dispatch({ type: EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_START });
  try {
    if (eventId > 0) {
      const event = await api.get(`api/general_competency_events/${eventId}`);
      dispatch({
        type: EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_END,
        payload: {
          event: {
            ...event,
            startDate: event.startDate ? new Date(event.startDate) : null,
            endDate: event.endDate ? new Date(event.endDate) : null
          }
        }
      });
    } else {
      dispatch({ type: EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_END });
    }
  } catch (error) {
    dispatch({ type: EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_END });
    throw error;
  }
};

export const saveEvent = (payload) => async(dispatch, getState, { api, history }) => {
  dispatch({ type: EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_START });
  const state = getState().generalCompetencyEventFormPage;
  const apiModel = {
    ...payload
  };
  let id = payload?.id;
  try {
    if (id > 0) {
      await api.put(`api/general_competency_events/${id}`, apiModel);
    } else {
      apiModel.status = apiModel.status || 'Draft';
      id = await api.post('api/general_competency_events', apiModel);
    }
    dispatch({
      type: EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_END,
      payload: {
        event: {
          ...state.event,
          id: id
        }
      }
    });
    history.back();
  } catch (error) {
    let validationResult = null;
    if (error instanceof ValidationError) {
      validationResult = {
        errorMessage: error.message,
        errors: error.errors
      };
    }
    dispatch({
      type: EventFormPageActionTypes.LOAD_EVENT_FORM_PAGE_END,
      payload: {
        validationResult,
        event: state.event
      }
    });
  }
};

export const cancelEventFormPage = () => async(dispatch, getState) => {
  const state = getState().generalCompetencyEventFormPage;
  state.cancellationTokenSources?.forEach(token => {
    token?.cancel();
  });
};
